export const PIN_LABEL = "Enter Pin";
export const PIN_TEST_ID = "pin-input";
export const PIN_LENGTH = 4;

export const DATA_TEST_IDS = {
    CTA: "pin-cta",
};

export const TEXTS = {
    TITLE: "Get the table PIN from {0}",
    SUB_TITLE: "Please ask {0} for the table PIN and start ordering",
    CTA: "Confirm PIN",
};

export const OBJECT_NAME = "pin-details";

export const OBJECT_VALUES = {
    IMPRESSION_CONTAINER: "impression-qr-menu-add-pin",
    CLICK_CONFIRM_CTA: "click-qr-menu-confirm-pin",
    CLICK_CLOSE_CTA: "click-qr-menu-close-pin",
};
